import './App.css';
import logo from './images/IMG_2217.JPG'

function App() {
  return (
    <div className="App">
      <main>
        <img src={logo} alt="saki c" />
        <p>@xsakisaki</p>
        <div className='btn-box'>
          <a href="https://glen-duckling-ca8.notion.site/6d590343b2dd474e988194c5c45de910?v=77dc732750db449ebc88b8e66100def2&pvs=4" target="_blank" rel="noreferrer">SHOP MY INSTAGRAM FEED</a>
          <a href="https://www.shopltk.com/explore/xsakisaki" target="_blank" rel="noreferrer">Shop my LikeToKnowIt</a>
          <a href="https://www.youtube.com/channel/UCQmtrZ532ZWV6xLFTFOI1Dw/featured" target="_blank" rel="noreferrer">Latest Youtube Video</a>
          <a href="https://www.tiktok.com/@xsakisaki" target="_blank" rel="noreferrer">Tik Tok</a>
          <a href="http://www.xsakisaki.com/" target="_blank" rel="noreferrer">My Blog: xsakisaki.com</a>
          <a href="http://www.xsakisaki.com/p/contact-me.html" target="_blank" rel="noreferrer">Contact Me</a>
          <a href="https://twitter.com/xsakisaki" target="_blank" rel="noreferrer">Twitter</a>
        </div>
      </main>
    </div>
  );
}

export default App;
